import React from 'react';
import { Share2, Facebook, Twitter, Smartphone, Copy } from 'lucide-react';

export default function MockupSkate() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white font-mono relative overflow-hidden selection:bg-[#2e6c2e] selection:text-white pb-24">
      {/* Noise overlay */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.85%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'}}></div>

      {/* Marquee Ticker */}
      <div className="w-full bg-[#2e6c2e] text-black font-black uppercase py-2 flex overflow-hidden border-b-4 border-black border-dashed">
         <div className="animate-marquee whitespace-nowrap text-sm tracking-widest">
           Ktoś zagłosował na Gdańsk · 36s temu // Ktoś zagłosował na Kraków · 1m temu // Ktoś zagłosował na Warszawa · 2m temu // Ktoś zagłosował na Wrocław · 4m temu // 
         </div>
      </div>

      <div className="max-w-7xl mx-auto p-4 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8 relative z-10 mt-8">
         {/* Hero & Branding */}
         <div className="lg:col-span-7 flex flex-col justify-center">
            <img src="https://customer-assets.emergentagent.com/job_skate-tour-1/artifacts/ahdsblol_LOGO%20SCOOTIVE.svg" className="h-12 md:h-16 w-auto mb-8 invert filter object-contain self-start" alt="Scootive" />
            
            <h1 className="text-6xl md:text-8xl font-black uppercase tracking-tighter leading-none mb-6 text-transparent bg-clip-text bg-gradient-to-br from-white to-gray-500 relative" style={{WebkitTextStroke: '2px white'}}>
               Scootive<br/>
               <span className="text-[#2e6c2e] drop-shadow-[4px_4px_0_rgba(255,255,255,1)]" style={{WebkitTextStroke: '0'}}>On Tour</span><br/>
               Sierpień '26
            </h1>
            
            <div className="flex gap-4 mb-12 font-bold text-2xl md:text-4xl border-l-4 border-[#2e6c2e] pl-4 items-center" data-testid="countdown-timer">
               <div className="flex flex-col items-center"><span>14</span><span className="text-xs text-gray-500">DNI</span></div><span className="text-[#2e6c2e] mb-4">:</span>
               <div className="flex flex-col items-center"><span>08</span><span className="text-xs text-gray-500">GODZ</span></div><span className="text-[#2e6c2e] mb-4">:</span>
               <div className="flex flex-col items-center"><span>45</span><span className="text-xs text-gray-500">MIN</span></div><span className="text-[#2e6c2e] mb-4">:</span>
               <div className="flex flex-col items-center text-[#2e6c2e]"><span>12</span><span className="text-xs text-[#2e6c2e]">SEK</span></div>
            </div>
         </div>

         {/* Vote Card */}
         <div className="lg:col-span-5 bg-black border-4 border-[#2e6c2e] p-8 relative shadow-[12px_12px_0_0_#2e6c2e] rotate-1 hover:rotate-0 transition-transform duration-300">
            <div className="absolute top-0 left-0 bg-[#2e6c2e] text-black text-xs font-bold px-3 py-1 uppercase -translate-y-[calc(100%+4px)] -translate-x-1 border-4 border-[#2e6c2e]">Wybierz Miasto</div>
            
            <label className="block text-sm mb-2 text-[#98FF98] uppercase tracking-widest font-bold">Wyszukaj miasto / skatepark</label>
            <div className="relative mb-8 group">
               <input data-testid="vote-city-input" type="text" className="w-full bg-transparent border-b-2 border-gray-600 text-2xl p-2 outline-none focus:border-[#2e6c2e] transition-colors uppercase text-white placeholder-gray-800" placeholder="WPISZ MIASTO..." />
               <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#2e6c2e] group-focus-within:w-full transition-all duration-300"></div>
            </div>

            <button data-testid="vote-submit-button" className="w-full bg-[#2e6c2e] text-black font-black text-3xl py-5 uppercase hover:bg-white hover:text-black hover:-translate-y-1 hover:shadow-[4px_4px_0_0_#98FF98] transition-all flex items-center justify-center gap-3 group">
               Zagłosuj <span className="group-hover:translate-x-2 transition-transform">→</span>
            </button>

            <div className="mt-10 pt-8 border-t-2 border-gray-900 border-dashed">
               <h3 className="text-xs text-gray-500 mb-4 uppercase tracking-widest">Udostępnij Kampanię</h3>
               <div className="flex justify-between md:justify-start gap-4">
                 <button data-testid="share-facebook" className="p-3 bg-gray-900 border border-gray-800 hover:border-[#2e6c2e] hover:text-[#2e6c2e] transition-colors"><Facebook size={20}/></button>
                 <button data-testid="share-twitter" className="p-3 bg-gray-900 border border-gray-800 hover:border-[#2e6c2e] hover:text-[#2e6c2e] transition-colors"><Twitter size={20}/></button>
                 <button data-testid="share-whatsapp" className="p-3 bg-gray-900 border border-gray-800 hover:border-[#2e6c2e] hover:text-[#2e6c2e] transition-colors"><Smartphone size={20}/></button>
                 <button data-testid="share-copy" className="p-3 bg-gray-900 border border-gray-800 hover:border-[#2e6c2e] hover:text-[#2e6c2e] transition-colors"><Copy size={20}/></button>
               </div>
            </div>
         </div>

         {/* Top 10 Mock */}
         <div className="lg:col-span-12 mt-16 border-t-4 border-gray-900 pt-12">
            <h2 className="text-3xl font-black mb-8 flex items-center gap-4 text-[#98FF98]">
               TOP 10 MIAST <span className="h-1 flex-1 bg-gray-900"></span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
               {[{n: "GDAŃSK", p: 85}, {n: "WARSZAWA", p: 60}, {n: "KRAKÓW", p: 45}, {n: "POZNAŃ", p: 30}, {n: "WROCŁAW", p: 25}].map((c,i) => (
                  <div key={i} className="flex flex-col gap-2">
                     <div className="flex justify-between text-lg font-bold">
                        <span><span className="text-gray-600 mr-2">0{i+1}</span> {c.n}</span>
                        <span className="text-[#2e6c2e]">{c.p}%</span>
                     </div>
                     <div className="h-4 w-full bg-gray-900 border border-gray-800 overflow-hidden relative">
                        <div className="absolute top-0 left-0 h-full bg-[#2e6c2e]" style={{width: `${c.p}%`}}>
                           <div className="w-full h-full opacity-30" style={{background: 'repeating-linear-gradient(45deg, transparent, transparent 10px, #000 10px, #000 20px)'}}></div>
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </div>
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .animate-marquee { display: inline-block; animation: marquee 15s linear infinite; }
      `}} />
    </div>
  );
}
